/*
  Belmont & Kensing — product-card colour swatches.
  Renders for products whose single option is Color/Colour (see snippets/card-swatches.liquid).
  On swatch click: selects the exact variant, swaps the card image, updates price/compare-at,
  and updates the hidden variant id used by the card's Add-to-cart form.
  Never adds a "first/wrong" variant silently — Add to cart always uses the selected swatch id.
*/
if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.card-wrapper') || this.closest('.card') || document;
        this.swatches = Array.from(this.querySelectorAll('.card-swatch'));
        if (!this.swatches.length) return;

        this.formId = this.getAttribute('data-form-id');

        this.swatches.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.select(btn);
          });
        });

        // Default to the first available swatch, otherwise the first swatch.
        const initial = this.swatches.find((b) => b.getAttribute('data-available') === 'true') || this.swatches[0];
        this.select(initial, true);
      }

      select(btn, isInitial) {
        if (!btn) return;

        this.swatches.forEach((b) => {
          const isSelected = b === btn;
          b.classList.toggle('is-selected', isSelected);
          b.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });

        this.updateVariantId(btn.getAttribute('data-variant-id'));
        this.updateImage(btn.getAttribute('data-variant-image'));
        this.updatePrice(btn.getAttribute('data-price'), btn.getAttribute('data-compare'));

        // The colour image lives on the first slide. If the shopper has arrowed
        // to another slide, snap back so the swatch change is actually visible.
        if (!isInitial) this.resetSlide();
      }

      // Return this card's Swiper instance, if the card has a carousel.
      swiperInstance() {
        if (!this.root.querySelector) return null;
        const host = this.root.querySelector('card-swiper');
        return host && host.swiper ? host.swiper : null;
      }

      resetSlide() {
        const swiper = this.swiperInstance();
        if (swiper && typeof swiper.slideTo === 'function') swiper.slideTo(0);
      }

      form() {
        if (this.formId) {
          const byId = document.getElementById(this.formId);
          if (byId) return byId;
        }
        return this.root.querySelector ? this.root.querySelector('form[data-type="add-to-cart-form"]') : null;
      }

      updateVariantId(variantId) {
        if (!variantId) return;
        let input = null;
        const form = this.form();
        if (form) input = form.querySelector('.product-variant-id');
        if (!input && this.root.querySelector) input = this.root.querySelector('.product-variant-id');
        if (input) input.value = variantId;
      }

      updateImage(imageUrl) {
        if (!imageUrl || !this.root.querySelector) return;
        const scope = this.root.querySelector('.card__media') || this.root;

        // Only swap the PRIMARY card image.
        // Previously this repainted EVERY <img> in the card media — including every
        // swiper slide and every loop clone — which made all slides show the same
        // picture until a swatch was clicked. Slides 2+ now keep their own unique
        // media so the carousel steps through distinct images.
        const primary =
          scope.querySelector('.swiper-slide:not(.swiper-slide-duplicate) img') ||
          scope.querySelector('img');
        if (!primary) return;

        primary.removeAttribute('srcset');
        primary.removeAttribute('sizes');
        primary.setAttribute('src', imageUrl);
      }

      updatePrice(price, compare) {
        if (!price || !this.root.querySelector) return;
        const priceEl = this.root.querySelector('.price');
        if (!priceEl) return;

        const regular = priceEl.querySelector('.price__regular .price-item--regular');
        if (regular) regular.textContent = price;

        const saleItem = priceEl.querySelector('.price__sale .price-item--sale');
        if (saleItem) saleItem.textContent = price;

        const onSale = Boolean(compare);
        priceEl.classList.toggle('price--on-sale', onSale);

        if (onSale) {
          const compareEl = priceEl.querySelector('.price__sale s') || priceEl.querySelector('s .price-item') || priceEl.querySelector('s');
          if (compareEl) compareEl.textContent = compare;
        }
      }
    }
  );
}
